import Button from '@modules/common/components/button';
import forgetPasswordSentSvg from './forget_password_sent.svg';

const ForgetPasswordSent = () => {
  return (
    <div className="text-black-30 flex flex-col items-center gap-y-8">
      <img
        src={forgetPasswordSentSvg}
        width={200}
        height={200}
        alt="sign_up_completed"
      />

      <p className="text-xl font-bold uppercase">重新設定密碼的連結已寄出</p>
      <p className="text-center">
        親愛的用戶，重新設定密碼的連結已寄送至您的電子信箱。
        <br />
        為了保障您的帳號安全，請登入您的電子信箱並點擊我們發送的重設密碼連結來設置新密碼。
        <br />
        祝您有個美好的一天！
      </p>
      <Button
        as="link"
        href="/account"
        data-testid="nav-login-link"
      >
        回到登入頁
      </Button>
    </div>
  );
};

export default ForgetPasswordSent;
